import { Avatar, Grid, makeStyles, Typography } from "@material-ui/core";
import React from "react";

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "row",
  },
  avatar: {
    marginRight: 10,
  },
});

function NameField({ name, symbol }) {
  const classes = useStyles();
  return (
    <Grid container>
      <Grid item className={classes.container}>
        <Avatar
          alt="Coin Image"
          src={`https://static.coincap.io/assets/icons/${symbol
            .toString()
            .toLowerCase()}@2x.png`}
          className={classes.avatar}
        />
        <div>
          <Typography variant="subtitle1">{name}</Typography>

          <Typography variant="caption">{symbol}</Typography>
        </div>
      </Grid>
    </Grid>
  );
}

export default NameField;
